// extracted by mini-css-extract-plugin
export default {"InputTooltip":"InputTooltip--JDSaH","InputTooltip__tooltip":"InputTooltip__tooltip--xQU3Q"};